<script setup lang="ts">
defineProps<{
  show: boolean
}>()
</script>

<template>
  <div v-if="show" class="fixed inset-0 z-50">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-gray-900 opacity-40"></div>

    <!-- Modal content -->
    <div class="absolute inset-0 flex items-center justify-center p-4">
      <div class="w-full max-w-[800px] h-full max-h-[600px]
               flex flex-col bg-white rounded-lg shadow-2xl overflow-hidden">
        <slot />
      </div>
    </div>
  </div>
</template>
